import { Injectable } from '@angular/core';
import { Http, RequestOptions, URLSearchParams ,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import {API_BASE_URL, ApplicationVariables, nodeSevice, AppConfig} from './config';
import { TokenManager } from './token-manager' ;
import { GVLogger } from '../services/gv-logger';
import { ApiOffline } from "./api-offline";
import { Storage } from '@ionic/storage';
import {NavController ,ToastController} from 'ionic-angular';
import {Settings} from "./settings";
import {CommonDataProvider} from "./common-data/common-data";
import {BehaviorSubject} from 'rxjs';
// import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import {CartManager} from './cart-manager';
import { RoutingInfo} from './data';



@Injectable()
export class Api {
  rtApiURL: string = API_BASE_URL;
  baseUrl: string = API_BASE_URL;
  dtApiURL: string =  '';

  private isFirstLogin = new BehaviorSubject(null);
  getIfFirstLogin = this.isFirstLogin .asObservable();
  nodeServiceUrl: any = nodeSevice;
  private imageUploaderUrl = ""


  constructor(public http: Http,
    private tokenManager:TokenManager,
    private gVLogger:GVLogger,
    private apiOffline:ApiOffline,
    private storage:Storage,
    private toastCtrl:ToastController,
    public commonDataProvider:CommonDataProvider,
    public cartManager : CartManager
    // public settings:Settings
  ) {

  }

  setURL(){
    // this.gVLogger.log("this.commonDataProvider.countryCode --- ", this.commonDataProvider.countryCode);
    let url = RoutingInfo;
    // this.gVLogger.log("getSaleCustomer " + JSON.stringify(url));


    this.dtApiURL =  url.dt + "api/v1";
    this.rtApiURL =  url.rt + "api/v2";

    this.imageUploaderUrl = RoutingInfo.imageUploaderUrl + "/api/v1";




    // this.dtApiURL =  "localhost:8081" + "api/v1";
    // this.rtApiURL =  "localhost:8081" + "api/v2";



    // if(this.commonDataProvider.countryCode === '+92'){
    //   this.gVLogger.log('setURL +92 ----- ');
    //   this.dtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_DTAPI_PK"];
    //   this.rtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_RTAPI_PK"];
    // }

    // else if(this.commonDataProvider.countryCode === '+1') {
    //   this.gVLogger.log('setURL +1 ----- ');
    //   this.dtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_DTAPI_NA"];
    //   this.rtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_RTAPI_NA"];
    //   this.gVLogger.log(this.dtApiURL, this.rtApiURL);
    // }
    // else if(this.commonDataProvider.countryCode === '')
    // {
    //   this.gVLogger.log('setURL 0 ----- ');
    //   this.dtApiURL =  AppConfig.LOCAL_DTAPI_PK;
    //   this.rtApiURL =  AppConfig.LOCAL_RTAPI_PK;
    // }
    // else{
    //   this.gVLogger.log('setURL --- countryCode --- ', this.commonDataProvider.countryCode)
    // }

    // this.gVLogger.log("set url..!!!" + this.rtApiURL);

      /*this.storage.get('countryCode').then((countryCode)=>{


        if(countryCode === '+92'){
          this.gVLogger.log('setURL +92 ----- ')
          this.dtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_DTAPI_PK"];
          this.rtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_RTAPI_PK"];
        }
        else if(countryCode === '+1') {
          this.gVLogger.log('setURL +1 ----- ')
          this.dtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_DTAPI_NA"];
          this.rtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_RTAPI_NA"];
          this.gVLogger.log(this.dtApiURL, this.rtApiURL);
        }
        else if(countryCode === 0)
        {
          this.gVLogger.log('setURL 0 ----- ')
          this.dtApiURL =  AppConfig.LOCAL_DTAPI_PK;
          this.rtApiURL =  AppConfig.LOCAL_RTAPI_PK;
        }
        else{
          if(countryCode === null)
            alert(countryCode+"    CountryCode is null");

          this.gVLogger.log('setURL --- countryCode --- ', countryCode)
        }
      });*/
  }

  get(endpoint: string, params?: any, options?: RequestOptions) {
    this.setURL();
    if (!options) {
      options = new RequestOptions();
    }
    this.gVLogger.log(this.tokenManager.getToken());
    let headers = new Headers({ 'token': this.tokenManager.getToken()});
    options = new RequestOptions({ headers: headers });
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for(let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }


    this.gVLogger.log(options);

 //   if(this.urlAvailable(endpoint)){
 //     return this.apiOffline.get(endpoint, options);
  //  }else{
    this.storage.get('countryCode').then();
      return this.http.get(this.rtApiURL + '/' + endpoint, options);

  //  }



  }

  getPassword(endpoint: string, params?: any, options?: RequestOptions) {
    // this.setURL();
    if (!options) {
      options = new RequestOptions();
    }
    this.gVLogger.log(this.tokenManager.getToken());
    let headers = new Headers({ 'token': this.tokenManager.getToken()});
    options = new RequestOptions({ headers: headers });
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for(let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }


    this.gVLogger.log(options);

    //   if(this.urlAvailable(endpoint)){
    //     return this.apiOffline.get(endpoint, options);
    //  }else{
    this.storage.get('countryCode').then();
    return this.http.get(this.baseUrl + '/' + endpoint, options);

    //  }



  }

  userAvailabilityRA(endpoint: string, body: any, reqOpts?: any){

    return this.http.post(AppConfig[AppConfig.ENVIRONMENT+"_RA_SERVICE"] + '/' + endpoint, reqOpts,{ params: body});
}

  post(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    let headers = new Headers({
      'Content-Type': 'application/json',
      'token':this.tokenManager.getToken()
      });

      // this.gVLogger.log("ttttokken", this.tokenManager.getToken());


    if(endpoint !="users/auth"){
       options = new RequestOptions({
        headers: headers
      });
    }
     //this.gVLogger.log(this.rtApiURL + '/' + endpoint);
   //  options.headers.append("uuid","test");
    return this.http.post(this.rtApiURL + '/' + endpoint, body, options);

  }

  postWithCustomHeaders(endpoint: string, body: any, headers: Headers) {
    this.setURL();
    // let headers = new Headers({
    //   'Content-Type': 'application/json',
    //   'token':this.tokenManager.getToken()
    // });

    // this.gVLogger.log("ttttokken", this.tokenManager.getToken());

    let options
    if(endpoint !="users/auth"){
      options = new RequestOptions({
        headers: headers
      });
    }
    //this.gVLogger.log(this.rtApiURL + '/' + endpoint);
    //  options.headers.append("uuid","test");
    return this.http.post(this.rtApiURL + '/' + endpoint, body, options);

  }

  postADPPay(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    let url = RoutingInfo;
    let headers = new Headers({
      'Content-Type': 'application/json',
      'token':this.tokenManager.getToken()
      });


    if(endpoint !="users/auth"){
       options = new RequestOptions({
        headers: headers
      });
    }
    // this.gVLogger.log(this.rtApiURL + '/' + endpoint, body, options);
     //this.gVLogger.log(this.rtApiURL + '/' + endpoint);
   //  options.headers.append("uuid","test");
   //  return this.http.post(AppConfig[AppConfig.ENVIRONMENT+"_ApiURL_billing"] + '/' + endpoint, body, options);
    return this.http.post(RoutingInfo.billingUrl + endpoint, body, options);

  }

  getADPPay(endpoint: string, params?: any, options?: RequestOptions) {
    this.setURL();
    if (!options) {
      options = new RequestOptions();
    }
    this.gVLogger.log(this.tokenManager.getToken());
    let headers = new Headers({ 'token': this.tokenManager.getToken()});
    options = new RequestOptions({ headers: headers });
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for(let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }


    this.gVLogger.log(options);

 //   if(this.urlAvailable(endpoint)){
 //     return this.apiOffline.get(endpoint, options);
  //  }else{
    this.storage.get('countryCode').then();
      // return this.http.get(AppConfig[AppConfig.ENVIRONMENT+"_ApiURL_billing"] + '/' + endpoint, options);
      return this.http.get(RoutingInfo.billingUrl + '/' + endpoint, options);

  //  }



  }


  postRA(endpoint: string, body: any, options?: RequestOptions) {
    let url = AppConfig[AppConfig.ENVIRONMENT+"_RA_SERVICE"];
    this.gVLogger.log("uuuuurrrlll" + url);
    // let url = AppConfig.LOCAL_RA_SERVICE;

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    options = new RequestOptions({
      headers: headers
    });
    // this.gVLogger.log("postRA - endpoint", url+endpoint);
    // this.gVLogger.log(body);
    return this.http.post(url + endpoint, body, options);
  }

  getRA(endpoint: string, options?: RequestOptions) {
    let url = AppConfig[AppConfig.ENVIRONMENT+"_RA_SERVICE"];
    this.gVLogger.log("uuuuurrrlll" + url);
    // let url = AppConfig.LOCAL_RA_SERVICE;

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    options = new RequestOptions({
      headers: headers
    });
    // this.gVLogger.log("postRA - endpoint", url+endpoint);
    // this.gVLogger.log(body);
    return this.http.get(url + endpoint);
  }

  postJazzba(endpoint: string, body: any, options?: RequestOptions) {

    let headers = new Headers({
      'Content-Type': 'application/json',
      'token':this.tokenManager.getToken()
      });


    if(endpoint !="users/auth"){
       options = new RequestOptions({
        headers: headers
      });
    }
     //this.gVLogger.log(this.url + '/' + endpoint);
   //  options.headers.append("uuid","test");
    return this.http.post(this.nodeServiceUrl + '/' + endpoint, body, options);
  }

  setIfFirstLogin(firstLoginState:boolean){
    this.isFirstLogin.next(firstLoginState)
    }


  geJazzba(endpoint: string, params?: any, options?: RequestOptions){
    this.setURL();
    if (!options) {
      options = new RequestOptions();
    }
    this.gVLogger.log(this.tokenManager.getToken());
    let headers = new Headers({ 'token': this.tokenManager.getToken()});
    options = new RequestOptions({ headers: headers });
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for(let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }


    this.gVLogger.log(options);

 //   if(this.urlAvailable(endpoint)){
 //     return this.apiOffline.get(endpoint, options);
  //  }else{
      return this.http.get(this.dtApiURL + '/' + endpoint, options);
  //  }


  }


  postlocal(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    let headers = new Headers({
      'Content-Type': 'application/json',
      'token': this.tokenManager.getToken()
    });


    if (endpoint != "users/auth") {
      options = new RequestOptions({
        headers: headers
      });
      return this.http.post(this.dtApiURL + '/' + endpoint, body, options);
    }
  }

//   gotoLogOut(){
//     // this.api.activateLoader();
//     this.get("user/logout").subscribe((res)=>{
//         localStorage.removeItem('currentUser');
//         localStorage.removeItem('countryCode');
//         localStorage.removeItem(AppConfig.prefix+'isLoggedIn');
//         this.router.navigate(['/extra/login']);
//         // this.api.hideLoader();
//     },err=>{
//         this.gVLogger.log(err);
//         //if (err.status == 401) {
//         localStorage.removeItem('currentUser');
//         localStorage.removeItem('countryCode');
//         localStorage.removeItem(APPCONFIG.prefix+'isLoggedIn');
//         this.router.navigate(['/extra/login']);
//         // this.api.hideLoader();
//         // }
//     });
// }




  getlocal(endpoint: string, params?: any, options?: RequestOptions) {
    this.setURL();
    if (!options) {
      options = new RequestOptions();
    }
    this.gVLogger.log(this.tokenManager.getToken());
    let headers = new Headers({ 'token': this.tokenManager.getToken()});
    options = new RequestOptions({ headers: headers });
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for(let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }


    this.gVLogger.log(options);

 //   if(this.urlAvailable(endpoint)){
 //     return this.apiOffline.get(endpoint, options);
  //  }else{
      return this.http.get(this.dtApiURL + '/' + endpoint, options);
  //  }



  }





  put(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    return this.http.put(this.rtApiURL + '/' + endpoint, body, options);
  }

  deletePost(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    return this.http.post(this.rtApiURL + '/' + endpoint, body, options);
  }

  patch(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    return this.http.put(this.rtApiURL + '/' + endpoint, body, options);
  }
  delete(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    return this.http.delete(this.rtApiURL + '/' + endpoint, options);
  }

  static nFormatter(num) {
    if(num == null){
      num = 0;
    }
    let digits = 1;
    var si = [
      { value: 1E18, symbol: "E" },
      { value: 1E15, symbol: "P" },
      { value: 1E12, symbol: "T" },
      { value: 1E9,  symbol: "B" },
      { value: 1E6,  symbol: "M" },
      { value: 1E3,  symbol: "k" }
    ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;
    for (i = 0; i < si.length; i++) {
      if (num >= si[i].value) {
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
      }
    }

    var ret = num.toFixed(digits).replace(rx, "$1");

    if(isNaN(ret)){
      ret = 0;
    }

    return ret;


  }



  urlAvailable(endpoint){
    if(ApplicationVariables.isOffline && endpoint.indexOf("customers/searchAll")!== -1){
      return true;
    }else{
      return false;
    }
  }


  toastMSG(msg){

    let t = this.toastCtrl.create({
      message:msg,
      duration:2000,
      position: 'bottom'
    });
    t.present();

  }



  getFullUrl(url: string, params?: any, options?: RequestOptions) {
    if (!options) {
      options = new RequestOptions();
    }
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for(let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }


    this.gVLogger.log(options);

 //   if(this.urlAvailable(endpoint)){
 //     return this.apiOffline.get(endpoint, options);
  //  }else{
      return this.http.get(url, options);
  //  }
 }

//  toastMsg(msg,action){
//   this.snackBar.open(msg, action, {
//       duration: 3500
//   });
// }


  imageUploaderPost(endpoint: string, body: any, docModuleId, docModule, countryAbbrivation, sourceUuid) {
    this.setURL();
    let headers = new Headers({
      'token':this.tokenManager.getToken(),
      'docModuleId' : docModuleId,
      'docModule' : docModule,
      'countryAbbrivation' : countryAbbrivation,
      'sourceUuid' : sourceUuid
      // 'parentInventoryLocationId' : 0
    });

    let options = new RequestOptions({
      headers: headers,
    });


    return this.http.post(this.imageUploaderUrl + endpoint, body, options);

  }


}



// WEBPACK FOOTER //
// ./src/providers/api.ts